import { createReducer } from "reduxsauce";
// import _ from "lodash";
import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/unit/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/unit/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import * as Helper from "../../../../utils/Helper";
import _ from "lodash";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.unit.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: vo => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        vo
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_ASYNC, vo });

            EditService.saveUnit(
                vo,
                response => {
                    dispatch(Actions.saveUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.saveUnitFailure(error, vo));
                }
            );
        };
    },

    saveUnitSuccess: (data) => ({
        type: ActionTypes.SAVE_UNIT_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        data
    }),

    saveUnitFailure: (error, vo) => ({
        type: ActionTypes.SAVE_UNIT_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        postReducer: saveUnitFailurePostReducer,
        error,
        saveUnitVO: vo
    }),

    saveAndCreateUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_AND_CREATE_UNIT_ASYNC, vo });

            EditService.saveUnit(
                vo,
                response => {
                    dispatch(Actions.saveAndCreateUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.saveAndCreateUnitFailure(error, vo));
                }
            );
        };
    },

    saveAndCreateUnitSuccess: (data) => ({
        type: ActionTypes.SAVE_AND_CREATE_UNIT_SUCCESS,
        parentType: ActionTypes.SAVE_AND_CREATE_UNIT_ASYNC,
        postReducer: saveAndCreateUnitSuccessPostReducer,
        data
    }),

    saveAndCreateUnitFailure: (error, vo) => ({
        type: ActionTypes.SAVE_AND_CREATE_UNIT_FAILURE,
        parentType: ActionTypes.SAVE_AND_CREATE_UNIT_ASYNC,
        postReducer: saveAndCreateUnitFailurePostReducer,
        error,
        saveUnitVO: vo
    }),

    selectUnitType: unitType => ({
        type: ActionTypes.SELECT_UNIT_TYPE,
        unitType
    }),

    selectTypeList: typeList => ({
        type: ActionTypes.SELECT_TYPE_LIST,
        typeList
    }),

    loadTaskUnitData: (taskUnitData, unitType) => ({
        type: ActionTypes.LOAD_TASK_UNITDATA,
        taskUnitData
    }),

    recreate: () => ({
        type: ActionTypes.RECREATE,
    }),

    searchByTypeId: (id) => ({
        type: ActionTypes.SEARCH_BY_TYPE_ID,
        id
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    unitTypeList: null,
    unitTypeListById: null,
    unit: {
        data: {}
    },
    unitData: null,

    // used as a temp unit id for unit related files uploading
    // for a new unit, uploaded files will be stored in a temp folder,
    // then when the unit is created ans saved, we will move those files
    // into the temp folder
    resourceId: ""
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { vo }) => {
    const { unitTypeList, unit } = vo;
    let newUnitTypeList = _.clone(unitTypeList);
    let index = newUnitTypeList.length - 1;
    while (index >= 0) {
        if (!newUnitTypeList[index].enabled)
            newUnitTypeList.splice(index, 1);
        index -= 1;
    }

    let newState = { ...state, unitTypeList: newUnitTypeList, resourceId: Helper.generateUUID() };
    if (unit) {
        newState = { ...newState, unit: { ...unit, data: JSON.parse(unit.data) } };
    }

    return newState;
};

const saveUnitFailurePostReducer = (state, { saveUnitVO }) => {
    let newUnit = { ...state.unit }
    newUnit.data = JSON.parse(saveUnitVO.data);
    return { ...state, unit: newUnit };
};

const saveAndCreateUnitSuccessPostReducer = (state) => {
    let newUnit = { ...state.unit }
    newUnit.data = {};
    newUnit.unitType = "";
    return { ...state, unit: newUnit, resourceId: Helper.generateUUID() };
};

const saveAndCreateUnitFailurePostReducer = (state, { saveUnitVO }) => {
    let newUnit = { ...state.unit }
    newUnit.data = JSON.parse(saveUnitVO.data);
    return { ...state, unit: newUnit };
};

const selectUnitTypeReducer = (state, { unitType }) => {
    const { unit } = state;
    return { ...state, unit: { ...unit, unitType: unitType.id, duration: unitType.duration } };
};

const selectTypeListReducer = (state, { typeList }) => {
    return { ...state, unitData: typeList }
};

const loadTaskUnitDataReducer = (state, { taskUnitData }) => {
    const unit = { ...taskUnitData, data: JSON.parse(taskUnitData.data) };
    return { ...state, unit }
};

const recreateReducer = (state) => {
    let newUnit = { ...state.unit }
    newUnit.data = {};
    newUnit.unitType = "";
    return { ...state, unit: newUnit, resourceId: Helper.generateUUID() };
};

const searchByTypeIdReducer = (state, { id }) => {
    const { unitTypeList } = state;
    let arr = [];
    let newUnitTypeList = _.clone(unitTypeList);
    for (let i = 0; i < newUnitTypeList.length; i++) {
        if (newUnitTypeList[i].id.indexOf(id.toUpperCase()) >= 0) {
            arr.push(newUnitTypeList[i]);
        }
    }
    if (id === "") {
        return { ...state, unitTypeListById: null };
    }
    return { ...state, unitTypeListById: arr };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SELECT_UNIT_TYPE]: selectUnitTypeReducer,
    [ActionTypes.SELECT_TYPE_LIST]: selectTypeListReducer,
    [ActionTypes.SAVE_AND_CREATE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_AND_CREATE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_AND_CREATE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_TASK_UNITDATA]: loadTaskUnitDataReducer,
    [ActionTypes.RECREATE]: recreateReducer,
    [ActionTypes.SEARCH_BY_TYPE_ID]: searchByTypeIdReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
